/*
 * @Author: 程序员
 * @Description: 错误码处理
 * @example: import ErrorCode from './errorCode.js'; let ec = ErrorCode['ok'];
 * @Date: 2021-06-07 09:47:30
 */
let errorCode = {
  //成功
  ok: ["0x00000000", 0],
  //保存失败
  error: "0X00000001",
  //数据无法支撑
  data_not_support: "0x00000001",
  //无权限
  no_permission: "0x00000010",
  //未认证
  not_authenticate: "0x00000011",
  //校验cid及uid不存在
  cid_uid_not_exist: "0x00000012",
  //校验cid错误
  cid_error: "0x00000013",
  //会话超时
  time_out_error: ["0x00000014", 401],
  //验证码错误
  varify_code_error: "0x00000031",
  //验证码超时
  varify_code_expire: "0x00000032",
  //入参错误
  input_error: "0x00000101",
  //操作数据库错误
  operate_sql_error: "0x00000102",
  //保存配置失败
  save_config_error: "0x00000103",
  //导出失败
  export_error: "0x00000104",
  //导入失败
  import_error: "0x00000105",
  //导入部分失败
  import_part_error: "0x00000106",
  //当前服务未激活
  license_check_error: "0x10000506",
};
export default errorCode;
